import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Topbar.css';

const Topbar = () => {
  const { user, logout } = useAuth();
  const [menuAbierto, setMenuAbierto] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickFuera = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuAbierto(false);
      }
    };
    document.addEventListener('mousedown', handleClickFuera);
    return () => document.removeEventListener('mousedown', handleClickFuera);
  }, []);

  const iniciales = user?.nombreCompleto
    ? user.nombreCompleto.trim().split(/\s+/).slice(0, 2).map((p) => p[0]).join('').toUpperCase()
    : 'XF';

  return (
    <header className="topbar">
      <div className="topbar-menu-wrapper" ref={menuRef}>
        <button
          className="topbar-avatar"
          onClick={() => setMenuAbierto((a) => !a)}
          title={user ? user.nombreCompleto : 'Menú'}
        >
          {iniciales}
        </button>

        {menuAbierto && (
          <div className="topbar-dropdown">
            {user && <span className="topbar-dropdown-nombre">{user.nombreCompleto}</span>}
            <Link to="/terminos" className="topbar-dropdown-link" onClick={() => setMenuAbierto(false)}>
              Términos y Condiciones
            </Link>
            <Link to="/aviso-privacidad" className="topbar-dropdown-link" onClick={() => setMenuAbierto(false)}>
              Aviso de Privacidad
            </Link>
            {user && (
              <button
                className="topbar-dropdown-link topbar-dropdown-logout"
                onClick={() => { setMenuAbierto(false); logout(); }}
              >
                Cerrar Sesión
              </button>
            )}
          </div>
        )}
      </div>
    </header>
  );
};

export default Topbar;
